<dx-popup
    #transactionLog
    minWidth="150px"
    minHeight="150px"
    width="50%"
    height="65%"
    [title]="title"
    [showCloseButton]="true"
    [shading]="false"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onHidden)="onPopClose()"
>
    <dx-box height="100%" width="100%" direction="col">
        <dxi-item [ratio]="1">
            <dx-data-grid
                width="100%"
                height="100%"
                [dataSource]="transactionLogResultData"
                [allowColumnReordering]="true"
                [allowColumnResizing]="true"
                [columnAutoWidth]="true"
                [showBorders]="true"
                [showColumnLines]="true"
                [showRowLines]="true"
                noDataText="No data to display"
            >
                <dxi-column dataField="beginStep" caption="Begin Value" dataType="string" [width]="115"></dxi-column>
                <dxi-column dataField="endStep" caption="End Value" dataType="string" [width]="115"></dxi-column>
                <dxi-column dataField="data" caption="Modified" dataType="string" [width]="115"></dxi-column>

                <dxi-column dataField="action" caption="Action" dataType="string" [width]="115"></dxi-column>

                <dxi-column
                    dataField="userInfo"
                    caption="User"
                    dataType="string"
                    [width]="130"
                    cellTemplate="userBioTemplate"
                ></dxi-column>
                <dxi-column
                    dataField="actionOn"
                    caption="Date"
                    dataType="date"
                    [width]="145"
                    [format]="dateTimeFormat"
                ></dxi-column>
                <dxi-column dataField="additionalInfo" dataType="string" caption="Additional Information"></dxi-column>

                <div *dxTemplate="let row of 'userBioTemplate'">
                    <app-user-bio-link [user]="row.value" [communityId]="communityId"></app-user-bio-link>
                </div>

                <dxo-header-filter [visible]="false"></dxo-header-filter>
                <dxo-filter-panel [visible]="false"></dxo-filter-panel>
                <dxo-group-panel [visible]="false"></dxo-group-panel>
                <dxo-sorting mode="none"></dxo-sorting>
                <dxo-scrolling mode="standard"></dxo-scrolling>
                <dxo-load-panel [enabled]="false"></dxo-load-panel>
            </dx-data-grid>
        </dxi-item>
        <dxi-item baseSize="auto">
            <dx-toolbar width="100%">
                <dxi-item location="before">
                    <div *dxTemplate class="button-container">
                        <dx-button type="default" text="Close" [icon]="iconClose" (onClick)="onPopClose()"></dx-button>
                    </div>
                </dxi-item>
            </dx-toolbar>
        </dxi-item>
    </dx-box>
</dx-popup>
